import styled, { css } from 'styled-components';
import { size } from '../../../styled-components/layout/helpers';
import { fadeIn, noTransform } from '../../../styled-components/layout/keyframes';

interface WrapperProps {
  $isOpenMobile?: boolean;
}

export const Wrapper = styled.nav<WrapperProps>`
  --navigation-bg: var(--c-mainnav-bg);
  --navigation-fg: var(--c-text-main);
  --navigation-border-color: var(--c-border-main);
  --navigation-active-bg: var(--c-mainnav-active-bg);
  --navigation-hover-bg: var(--c-mainnav-hover-bg);
  --navigation-accent-bg: var(--c-primary-bg);
  --navigation-accent-fg: var(--c-primary-fg);
  --navigation-sidenav-width: ${size(13)};
  --navigation-mainnav-width: ${size(36)};
  --navigation-foldout-animation-duration: 150ms;
  --navigation-mobile-animation-duration: 150ms;
  --z-index-foldout: 25;
  --z-index-foldout-overlay: 20;
  --z-index-mainnav-close-btn: 10;

  position: relative;
  display: flex;
  color: var(--navigation-fg);

  ${(props) => props.theme.breakpoint.LtMd} {
    display: none;
    position: fixed;
    inset: 0;
    max-width: max-content;
    z-index: ${(props) => props.theme.zindex.mainNavigation};

    ${({ $isOpenMobile }) =>
      $isOpenMobile &&
      css`
        display: flex;
      `}

    transform: translateX(-100%);
    animation: ${noTransform} var(--navigation-mobile-animation-duration) ease forwards;
  }

  ${(props) => props.theme.breakpoint.Md} {
    background-color: var(--navigation-bg);
  }
`;

// Overlay placed behind navigation on small screens
export const Overlay = styled.div.attrs(() => ({
  'aria-hidden': true,
  role: 'button',
}))`
  position: fixed;
  inset: 0;
  background-color: var(--c-mainnav-overlay);
  animation: ${fadeIn} var(--navigation-mobile-animation-duration) ease;
  z-index: ${(props) => props.theme.zindex.mainNavigationOverlay};

  ${(props) => props.theme.breakpoint.Md} {
    display: none;
  }
`;
